import React from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	ageButtonGrid: {
		marginTop: 7,
		marginBottom: 7,
	},
	ageButton: {
		borderRadius: "50%",
		padding: 30,
	},
}));

const IncreaseAge = ({ upAgeHandler }) => {
	const classes = useStyles();

	return (
		<Grid
			className={classes.ageButtonGrid}
			container
			direction="column"
			justify="center"
			alignItems="center"
		>
			<Grid item xs={8}>
				<Button
					className={classes.ageButton}
					variant="contained"
					color="primary"
					onClick={upAgeHandler}
				>
					Age
				</Button>
			</Grid>
		</Grid>
	);
};

export default IncreaseAge;
